.featureRow {
    margin-bottom: 10px;
}

.leftPaddingMatchingSwitches {
    /* The width of a Switch + the padding between it and its label. */
    padding-left: 62px;
}

.toggleAndName {
    display: flex;
    align-items: center;
    gap: 4px;
}
